export default __webpack_public_path__ + "static/media/dashboard-gdi-logo.34bfbd79.png";